export const VIDEO_EXTENSIONS =
  /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
export const MATCH_URL_VKVIDEO =
  /(?:vk\.com|(?:[\w]+\.)?vkvideo\.ru|m\.vk\.com)(?:\/video)?(?:\?z=video)?(?:\?oid=)?(-?\d+)[_&](\d+)/;
export const MATCH_URL_RUTUBE =
  /https?:\/\/(?:www\.|sport\.|news\.|kids\.)?rutube\.(?:ru|com|sport)\/video\/([^\/\?]+)\/?/;

const canPlayFile = (url: string, test: (u: string) => boolean) => {
  if (Array.isArray(url)) {
    for (const item of url) {
      if (typeof item === 'string' && canPlayFile(item, test)) {
        return true;
      }
      if (canPlayFile(item.src, test)) {
        return true;
      }
    }
    return false;
  }
  return test(url);
};

export const canPlay = {
  html: (url: string) =>
    canPlayFile(url, (u: string) => VIDEO_EXTENSIONS.test(u)),
  vkvideo: (url: string) => MATCH_URL_VKVIDEO.test(url),
  rutube: (url: string) => MATCH_URL_RUTUBE.test(url),
};
